<template>
  <div class="product-hitches">
    <input type="hidden" name="loader_hitch_options" v-model="optionsImploded" />

    <div class="form-group">
      <label for="show_loader_hitch">Show Loader Hitch Options</label>
      <input type="checkbox" id="show_loader_hitch" name="show_loader_hitch" v-model="product.show_loader_hitch">
    </div>

    <table class="table table-bordered" v-if="product.loader_hitch_options">
      <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(op, index) in product.loader_hitch_options" :key="index">
          <td>
            {{index + 1}}
          </td>
          <td>
            <input type="text" class="form-control" v-model="op.name"/>
          </td>
          <td>
            <button class="btn btn-sm btn-link" type="button" @click="remove(index)">
              <i class="fas fa-trash-alt text-danger"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="text-right">
      <button class="button button-primary" type="button" @click="add">
        <i class="fas fa-circle-plus"></i>
        Add loader hitch option
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: "ProductHitches",
  props: ['product'],
  data(){
    return {
      models: [],
    }
  },
  mounted() {
    if(!this.product.loader_hitch_options) {
      this.$set(this.product, 'loader_hitch_options', [])
    }
  },
  methods: {
    add(){
      if(!this.product.loader_hitch_options) {
        this.$set(this.product, 'loader_hitch_options', [])
      }

      this.product.loader_hitch_options.push({
        name: ''
      })
    },
    remove(index){
      let model = this.product.loader_hitch_options[index]
      if(!model){
        return
      }

      if(!model.name){
        return this.product.loader_hitch_options.splice(index, 1)
      }

      $.confirm({
        title: '',
        content: `<div style="font-size: 1.3em">Are you sure want to delete this item?</div>`,
        buttons: {
          confirm: {
            text: 'Ok',
            btnClass: 'btn btn-success',
            keys: ['enter'],
            action: () => {
              this.product.loader_hitch_options.splice(index, 1)
            }
          },
          cancel: {
            text: 'Cancel',
            btnClass: 'btn btn-danger',
            keys: ['esc', 'escape'],
          },
        }
      })
    }
  },
  computed: {
    optionsImploded(){
      return JSON.stringify(this.product.loader_hitch_options)
    }
  }
}
</script>

